import type { PropertyDTO } from "@zplanem/responses"
import { webPaths } from "@zplanem/web-paths"
import { Link } from "react-router-dom"
import { getTranslations } from "../i18n"
import { useLocale } from "../locale-context"
import { PropertyTypeBadge } from "./property-type-badge"

interface Props {
	property: PropertyDTO
}

export function PropertyHeroCard({ property }: Props) {
	const { locale } = useLocale()
	const t = getTranslations(locale)

	return (
		<Link
			to={webPaths.property(property.id)}
			className="block min-w-0 bg-muted/40 backdrop-blur-md rounded-lg border border-border p-8 hover:border-foreground/25 transition-colors"
		>
			<div className="flex items-baseline gap-3">
				<PropertyTypeBadge property={property} />
				<span className="text-xs text-muted-foreground/80">
					{t.properties.lastOpenedLabel}
				</span>
			</div>
			<h2 className="text-4xl font-black text-foreground tracking-tight mt-2">
				{property.name}
			</h2>
			{(property.descriptionShort ?? property.description) ? (
				<p className="mt-4 text-base text-foreground/80 leading-relaxed line-clamp-3">
					{property.descriptionShort ?? property.description}
				</p>
			) : null}
		</Link>
	)
}
